import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/authContext';
import ThemeToggle from './ThemeToggle';
import logo from '../assets/images/logo.jpeg';
import { apiService } from '../services/apiService';

const Navbar = ({ toggleSidebar }) => {
  const { user, logout } = useAuth();
  const [showDropdown, setShowDropdown] = useState(false);
  const [unreadCount, setUnreadCount]   = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    if (!user) return;
    const fetchUnread = () => {
      apiService.get('notifications/unread').then(d => setUnreadCount(d?.count || 0)).catch(() => {});
    };
    fetchUnread();
    const interval = setInterval(fetchUnread, 60000);
    return () => clearInterval(interval);
  }, [user]);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const initials = user
    ? `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`
    : 'U';

  return (
    <nav className="navbar">
      <div className="navbar-left">
        <button className="menu-toggle" onClick={toggleSidebar} aria-label="Toggle menu">☰</button>
        <div className="navbar-brand">
          <Link to="/dashboard">
            <img src={logo} alt="MCCT" style={{ height: 40, width: 'auto', borderRadius: 4 }} />
          </Link>
        </div>
      </div>

      <div className="navbar-search">
        <input type="text" placeholder="Search…" className="search-input" />
        <button className="search-button">🔍</button>
      </div>

      <div className="navbar-right">
        <ThemeToggle />

        <div className="navbar-notifications">
          <Link to="/notifications" className="notification-button">
            🔔
            {unreadCount > 0 && <span className="notification-badge">{unreadCount}</span>}
          </Link>
        </div>

        <div className="navbar-user">
          <button className="user-button" onClick={() => setShowDropdown(d => !d)}>
            <div className="user-avatar">{initials}</div>
            <span className="user-name hide-on-mobile">
              {user ? `${user.firstName} ${user.lastName}` : 'User'}
            </span>
          </button>

          {showDropdown && (
            <div className="user-dropdown">
              <Link to="/settings" className="dropdown-item" onClick={() => setShowDropdown(false)}>
                Profile &amp; Settings
              </Link>
              <button className="dropdown-item logout-button" onClick={handleLogout}>
                Logout
              </button>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
